import React, { Component } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import MainPage from './pages/MainPage'
import Nav from './components/Header/Nav'
import Footer from './components/Footer/Footer'
import AboutUs from './pages/AboutUs'
import Projects from './pages/Projects'
import Services from './pages/Services'
import Blogs from './pages/Blogs'
import SingleBlog from './pages/SingleBlog'
import ContactUs from './pages/ContactUs'

import blogData from './actions/blogs.json'
import ScrollToTop from './components/ScrollToTop'


export class App extends Component {
  render() {
    return (
      <div >
        <BrowserRouter>
          <ScrollToTop />
          <Nav />
          <Routes>
            <Route path='/' element={<MainPage />} />
            <Route path='/about-us' element={<AboutUs />} />
            {/* <Route path='/project' element={<Projects />} /> */}
            <Route path='/services' element={<Services />} />
            <Route path='/contact-us' element={<ContactUs />} />

            <Route path='/blogs' element={<Blogs blogs={blogData} />} />
            <Route path="/blogs/:path" element={<SingleBlog blogs={blogData} />} />

          </Routes>
          <Footer />
        </BrowserRouter>
      </div>
    )
  }
}

export default App